export * from './envs';
export * from './cookieYes';
export * as EVENTS from './events';

export const TERMS_LINK = 'https://family-locator.com/terms-of-use-info';
export const POLICY_LINK = 'https://family-locator.com/privacy-policy-info';
export const EBANX_BR_PAYMENT_TERMS_LINK =
  'https://www.ebanx.com/pt-br/legal/consumidores/brasil/termos-para-processar-pagamentos/';
export const APP_LINK = 'https://family-locator.com';
export const APP_ONE_LINK = 'https://family-locator.onelink.me/eb3y';
export const SUPPORT_EMAIL = 'help@family-locator.com';
export const SESSION_STORAGE_TOKEN_KEY = 'access_token';
export const FBC_PARAM = '_fbc';
export const FBP_PARAM = '_fbp';
export const TTP_PARAM = '_ttp';
export const OPPREF_COOKIE = '__oppref';
export const COOKIE_UUID_KEY = 'userUuid';
export const PRODUCT_NAME = 'Family Locator';
export const GOOGLE_ADS_OB_START_ID = 'rVNrCIST9MUZEJqgyZQB';
export const GOOGLE_ADS_CONVERSION_ID = 'hF84CIGT9MUZEJqgyZQB';
export const GOOGLE_ADS_LEAD_EMAIL_ID = 'JSMTCNSa9o8cEPDnrZtD';
export const GOOGLE_ADS_INTRO_ACTIVATED_FRONT_ID = '3YTRCIPi9o8cEPDnrZtD';
export const GOOGLE_ADS_PURCHASE_FRONT_ID = '1udzCJiY948cEPDnrZtD';
export const GOOGLE_ADS_ACCOUNT_ID = '9203700535-WEB-FL';
export const GOOGLE_ADS_PLTV_ACCOUNT_ID = '2404849707-WEB-FL-PLTV';
export const GOOGLE_ADS_PLTV_ACCOUNT_SUFFIX = '-WEB-FL-PLTV';
export const GOOGLE_ADS_PLTV_ACCOUNTS = [
  '5032681927',
  '6542400103',
  '4325001000',
  '3334723947',
  '9734576174',
  '2120660086',
  '2404849707',
];
export const GOOGLE_ADS_REVIEW_ACCOUNT_ID = '2530921137-WEB-SF';
export const GOOGLE_ADS_SGTM_ACCOUNT_ID = '9203700535-WEB-FL-SGTM';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_1 = '8suRCLujyakcEJqPgcJD';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_2 = '38eOCMLWsqkcEKP6_8FD';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_3 = 'kXhCCOSsyqkcEJWs_8FD';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_4 = 'UVyFCO-Jw6scEIvP3tFD';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_5 = 'pmcGCMGX08wcEOXR9oZE';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_6 = 'aNRoCM2e6swcEInz-4ZE';
export const GOOGLE_ADS_LTV_CONVERSION_LABEL_7 = 'CoN7COGT7cwcEKq__YZE';
export const PL_VALUE_LANDING = 'pl_value';
export const PLTV_LANDINGS = [
  PL_VALUE_LANDING,
  'lp17ch18p3_all5',
  'lp17ch18p3_all5_ft3',
  'lp1ch4',
  'lp17ch17p5',
  'lp1ch3',
  'lp14ch8',
  'ec_of3',
  'up',
  'px',
  'lgpw',
  'hdl_kw',
  'blk',
  'flpm_rt',
  'plv_lng_tst',
];

export const DEFAULT_DELAYED_TIME = 300;

export const PAYMENT_GATEWAY_PROPERTY = 'Payment gateway';

export const STRIPE_ACCOUNT_FALLBACK = {
  CARD: 'CARD',
  PIX: 'PIX',
  UPI: 'UPI',
  BLIK: 'BLIK',
  CASH_APP: 'CASH_APP',
} as const;
export type StripeAccountFallback =
  (typeof STRIPE_ACCOUNT_FALLBACK)[keyof typeof STRIPE_ACCOUNT_FALLBACK];
export const PAYMENT_GATEWAY = {
  BRAINTREE: 'Braintree',
  stripe: (accountName: string | null | undefined, fallback: StripeAccountFallback) =>
    `Stripe [${accountName || fallback}]`,
} as const;

export const FROM_REVIEW_PARAM = 'from_review';
export const REVIEW_CLICK_ID_PARAM = 'review_click_id';
export const REVIEW_SOURCE_KEY = 'review_source';
export const REVIEW_CLICK_ID_KEY = 'review_click_id';
export const REVIEW_TS_KEY = 'review_ts';
export const REVIEW_COOKIE_DAYS = 30;
export const GOOGLE_ADS_REVIEW_CONVERSION_ID = 'wTf3CO37-fYbELnHke1C';
